// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mds-header .container h2 {
    color: red
}

.wrapper {
	width: 100%;
	position: relative;
}
/* :root {
  --color-primary-orange: #f28f34;
} */

.topbar {
	position: fixed;
	top: 0;
	left: 270px;
	right: 0;
	height: 45px;
	background: var(--color-primary-orange);
	/* border-bottom: 1px solid rgb(228 228 228 / 0%); */
	z-index: 150;
 box-shadow: 0 2px 6px 0 rgb(218 218 253 / 65%), 0 0px 6px 0 rgb(206 206 238 / 54%);
	transition: left 0.3s ease;
}

.topbar .navbar {
	width: 100%;
	height: 45px;
	padding-left: 30px;
	padding-right: 30px;
	justify-content: flex-end;
}

.topbar .navbar .navbar-nav .nav-link {
	padding-right: .8rem;
	padding-left: .8rem;
	color: var(--color-text-dark);
	font-size: 22px
}

.user-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    width: 55px;
    border-left: 0px solid var(--color-border-light);
    margin-left: 1rem;
    margin-right: -1rem;
    padding-left: 0;
}

.user-img {
	width: 38px;
    height: 38px;
    border-radius: 50%;
    border: 0 solid #e5e5e5;
    padding: 0;
    font-size: 32px;
    color: var(--color-icon-muted);
}

.user-info .user-name {
	font-size: 15px;
	font-weight: 500;
	color: var(--color-white)
}

.user-info .designattion {
	font-size: 13px;
	color: var(--color-white)
}

.user-box .dropdown-menu i {
	vertical-align: middle;
	margin-right: 10px
}

.dropdown-menu {
	box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15);
	border: 0 solid var(--color-border-light);
	border-radius: 10px;
	font-size: 14px
}

.dropdown-toggle-nocaret:after {
	display: none
}

.topbar .navbar .dropdown-large .dropdown-menu::after {
	content: '';
	width: 13px;
	height: 13px;
	background: var(--color-white);
	position: absolute;
	top: -6px;
	right: 16px;
	transform: rotate(45deg);
	border-top: 1px solid #ddd;
	border-left: 1px solid #ddd
}

.topbar .navbar .dropdown-menu::after {
	content: '';
	width: 13px;
	height: 13px;
	background: var(--color-white);
	position: absolute;
	top: -6px;
	right: 16px;
	transform: rotate(45deg);
	border-top: 1px solid #ddd;
	border-left: 1px solid #ddd
}

.topbar .navbar .dropdown-menu {
	animation: .6s cubic-bezier(.25, .8, .25, 1) 0s normal forwards 1 animdropdown
}
.designation-icon {
    color: var(--color-icon-muted);
    font-size: 15px;
    width: 20px;
    flex-shrink: 0;
    text-align: center;
    margin-top: 2px;
    margin-left: 15px;
}

.designation-text {
    font-size: 14px;
    color: var(--color-text-dark);
    line-height: 1.4;
}

.company-select-box {
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 38px;
    padding: 8px 14px;
    background: var(--color-white);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;
}

.company-selected-text {
    color: var(--color-text-dark);
    font-size: 14px;
    flex: 1 1;
    padding-left: 8px;
    white-space: normal;
    word-break: break-word;
    line-height: 1.4;
}

.company-arrow {
    margin-top: 2px;
}

/* .company-arrow {
    color: #6c757d;
    font-size: 9px;
    margin-left: auto;
} */

.custom-company-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    right: 0;
    background: var(--color-bg-panel);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
    list-style: none;
    margin: 0;
    padding: 6px 0;
    z-index: 20;
    max-height: 220px;
    overflow-y: auto;
}

.custom-company-dropdown li {
    padding: 10px 14px;
    color: var(--color-text-dark);
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}

.custom-company-dropdown li:hover {
    background: rgba(0, 0, 0, 0.05);
}

.custom-company-dropdown li.active {
    color: var(--color-primary-orange);
    font-weight: 600;
}
.topbar .navbar .dropdown-menu {
    background: var(--color-bg-panel);
	border: 1px solid rgba(0, 0, 0, 0.08);
    min-width: 260px;
    border-radius: 14px;
    overflow: visible;
}

.dropdown-user-img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: var(--color-white);
    color: var(--color-primary-green);
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}

.dropdown-user-info .user-name {
    font-size: 15px;
    /* font-weight: 600; */
    color: var(--color-text-dark);
}

.dropdown-user-info .designattion {
    font-size: 13px;
    color: var(--color-text-dark);
}
.topbar .navbar .dropdown-menu::after {
    border-radius: 2px;
}
.topbar .navbar .dropdown-menu .dropdown-item {
    color: var(--color-text-dark) !important;
    opacity: 1 !important;
    background: transparent !important;
	padding: 4px 14px !important;
}

.topbar .navbar .dropdown-menu .dropdown-item:hover {
    background: transparent !important;
    color: #7f8991 !important;
}
.company-select-box .company-select option {
    background: var(--color-bg-panel);
    color: var(--color-text-dark);
    font-size: 14px;
    font-family: inherit;
    padding: 8px 12px;
}

.company-select-box .company-select option:checked,
.company-select-box .company-select option:hover {
    background: var(--color-primary-orange);
    color: var(--color-white);
}
.topbar .navbar .dropdown-menu .dropdown-divider {
    margin: 0 !important;
}

.mobile-portal-toggle {
	display: none;
}

@media (max-width: 768px) {
	.topbar .navbar > div[style*="display: flex"] > .portal-toggle-container,
	.topbar .navbar .portal-toggle-container {
		display: none !important;
	}

	.ticketing-link {
		display: none !important;
	}

	.mobile-portal-toggle {
		display: flex !important;
	}
    .user-info {
		padding-right: 18px;
	}
}
@media (max-width: 768px) {
  .ticketing-link {
    display: none !important;
  }
}
.mobile-quick-links {
    display: none;
}

@media (max-width: 768px) {
    .mobile-quick-links {
        display: block;
    }
}

.mobile-quick-link-item {
    display: flex;
    align-items: center;
    padding: 8px 0;
    color: var(--color-text-dark);
    font-size: 14px;
    cursor: pointer;
    margin-left: 10px;
}

.mobile-quick-link-item:hover {
    color:var(--color-primary-orange);
}

.mobile-quick-link-item i {
    color:var(--color-primary-orange);
    width: 20px;
}
@media (max-width: 768px) {
    .topbar {
    height: 45px;
  }
  .topbar .navbar {
    height: 45px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .toggle-menu {
    height: 56px;
    padding: 0 10px !important;
    font-size: 20px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  
  .company-logo {
    width: 32px !important;
    height: 45px !important;
    padding: 0 !important;
    margin: 0 !important;
    object-fit: contain;
    display: block;
  }
  .user-info {
    padding-left: 1px !important;
    padding-right: 1px !important;
    color: var(--color-primary-green) !important;
    /* background-color: var(--color-primary-green) !important; */
  }

  .dropdown-user-img {
    width: 28px !important;
    height: 28px !important;
    font-size: 18px !important;
     margin-left: -10px;
  }
  
}
.dropdown-item-icon {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: 10px;
}

.dropdown-item-icon i {
    width: 20px;
    text-align: center;
    color:var(--color-primary-green);
    flex-shrink: 0;
    
}
.dropdown-icon-self {
    width: 10px;
    text-align: center;
    color: var(--color-primary-green);
    flex-shrink: 0;
    
}
.quick-apps-trigger {
    height: 32px;
    width: 32px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--color-white);
    font-size: 15px;
}

.quick-apps-trigger:hover {
    background: rgba(255, 255, 255, 0.4);
}

.quick-apps-panel {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    background: var(--color-white);
    border-radius: 14px;
    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.15);
    padding: 16px;
    display: flex;
    gap: 20px;
    z-index: 200;
}

.quick-apps-panel::after {
    content: '';
    position: absolute;
    top: -6px;
    right: 16px;
    width: 13px;
    height: 13px;
    background: var(--color-white);
    transform: rotate(45deg);
    box-shadow: -2px -2px 3px -1px rgba(0, 0, 0, 0.06);
}

.quick-app-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    width: 70px;
}

.quick-app-item span {
    font-size: 12px;
    color: var(--color-text-dark);
    text-align: center;
    line-height: 1.3;
}

.quick-app-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-white);
    font-size: 20px;
}

.quick-app-icon-red { background: #e0435c; }
.quick-app-icon-teal { background: #14a89d; }

.quick-links-trigger {
    display: flex;
    align-items: center;
    gap: 8px;
    background: var(--color-primary-orange);
    color: var(--color-white);
    font-size: 0.8rem;
    font-weight: 600;
    padding: 6px 14px;
    border-radius: 20px;
    cursor: pointer;
    border: 1px solid var(--color-primary-green);
    transition: background 0.2s ease, border-color 0.2s ease;
}

.quick-links-trigger:hover {
    background: var(--color-primary-green);
    border-color: var(--color-primary-green);
}

.quick-links-trigger-active {
    background: var(--color-primary-green) !important;
    border-color: var(--color-primary-green) !important;
}

.quick-links-chevron {
    font-size: 11px;
    transition: transform 0.2s ease;
}

.quick-links-chevron-open {
    transform: rotate(180deg);
}

.quick-links-panel {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    background: var(--color-white);
    border-radius: 14px;
    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.15);
    padding: 6px 0;
    display: flex;
    flex-direction: column;
    gap: 0;
    z-index: 200;
}

.quick-link-card {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px 16px;
    cursor: pointer;
    border-bottom: 1px solid #eef0f2;
    transition: background 0.2s ease;
    white-space: nowrap;
}

.quick-link-card:last-child {
    border-bottom: none;
}

.quick-link-card:hover {
    background: var(--color-bg-hover);
}

.quick-link-card-icon {
    font-size: 14px;
    color: var(--color-primary-orange);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.quick-link-divider {
    width: 1px;
    height: 18px;
    background: rgba(255, 255, 255, 0.3);
}
.portal-toggle-container-mobile {
    display: inline-flex;
    width: 100%;
    background: var(--color-white);
    border-radius: 20px;
    padding: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border: 1px solid var(--color-border-light);
}

.portal-toggle-btn {
    flex: 1 1;
    cursor: pointer;
    font-weight: 500;
    font-size: 13px;
    padding: 6px 16px;
    border-radius: 16px;
    border: none;
    transition: all 0.3s ease;
    white-space: nowrap;
    background: transparent;
    color: #666666;
}

.portal-toggle-btn-active {
    background: var(--color-primary-green);
    color: var(--color-white);
}`, "",{"version":3,"sources":["webpack://./src/containers/header/Header.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;AACA;;GAEG;;AAEH;CACC,eAAe;CACf,MAAM;CACN,WAAW;CACX,QAAQ;CACR,YAAY;CACZ,uCAAuC;CACvC,oDAAoD;CACpD,YAAY;CAET,kFAAkF;CACrF,0BAA0B;AAC3B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,6BAA6B;CAC7B;AACD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,gDAAgD;IAChD,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;CACC,WAAW;IACR,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;IACV,eAAe;IACf,8BAA8B;AAClC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CAEC,2CAA2C;CAC3C,yCAAyC;CACzC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,WAAW;CACX,YAAY;CACZ,8BAA8B;CAC9B,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,wBAAwB;CACxB,0BAA0B;CAC1B;AACD;;AAEA;CACC,WAAW;CACX,WAAW;CACX,YAAY;CACZ,8BAA8B;CAC9B,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,wBAAwB;CACxB,0BAA0B;CAC1B;AACD;;AAEA;CAEC;AACD;AACA;IACI,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;IAC9B,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,SAAO;IACP,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;GAIG;;AAEH;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,iCAAiC;IACjC,qCAAqC;IACrC,mBAAmB;IACnB,4CAA4C;IAC5C,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;AACpB;AACA;IACI,iCAAiC;CACpC,qCAAqC;IAClC,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,iCAAiC;IACjC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,wCAAwC;IACxC,qBAAqB;IACrB,kCAAkC;CACrC,4BAA4B;AAC7B;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;AAC7B;AACA;IACI,iCAAiC;IACjC,6BAA6B;IAC7B,eAAe;IACf,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;;IAEI,uCAAuC;IACvC,yBAAyB;AAC7B;AACA;IACI,oBAAoB;AACxB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC;;EAEC,wBAAwB;CACzB;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,wBAAwB;CACzB;IACG;EACF,mBAAmB;CACpB;AACD;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,WAAW;AACf;AACA;IACI;IACA,YAAY;EACd;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,0BAA0B;IAC1B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;;EAGA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,4CAA4C;IAC5C,6DAA6D;EAC/D;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;KACzB,kBAAkB;EACrB;;AAEF;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;;AAElB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,iCAAiC;IACjC,cAAc;;AAElB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;IACR,8BAA8B;IAC9B,mBAAmB;IACnB,+CAA+C;IAC/C,aAAa;IACb,aAAa;IACb,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,wBAAwB;IACxB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;AACnB;;AAEA,sBAAsB,mBAAmB,EAAE;AAC3C,uBAAuB,mBAAmB,EAAE;;AAE5C;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,uCAAuC;IACvC,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,4CAA4C;IAC5C,wDAAwD;AAC5D;;AAEA;IACI,sCAAsC;IACtC,wCAAwC;AAC5C;;AAEA;IACI,iDAAiD;IACjD,mDAAmD;AACvD;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;IACR,8BAA8B;IAC9B,mBAAmB;IACnB,+CAA+C;IAC/C,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,oCAAoC;AACxC;AACA;IACI,oBAAoB;IACpB,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,wCAAwC;IACxC,2CAA2C;AAC/C;;AAEA;IACI,SAAO;IACP,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,yBAAyB;AAC7B","sourcesContent":[".mds-header .container h2 {\n    color: red\n}\n\n.wrapper {\n\twidth: 100%;\n\tposition: relative;\n}\n/* :root {\n  --color-primary-orange: #f28f34;\n} */\n\n.topbar {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 270px;\n\tright: 0;\n\theight: 45px;\n\tbackground: var(--color-primary-orange);\n\t/* border-bottom: 1px solid rgb(228 228 228 / 0%); */\n\tz-index: 150;\n\t-webkit-box-shadow: 0 2px 6px 0 rgb(218 218 253 / 65%), 0 0px 6px 0 rgb(206 206 238 / 54%);\n    box-shadow: 0 2px 6px 0 rgb(218 218 253 / 65%), 0 0px 6px 0 rgb(206 206 238 / 54%);\n\ttransition: left 0.3s ease;\n}\n\n.topbar .navbar {\n\twidth: 100%;\n\theight: 45px;\n\tpadding-left: 30px;\n\tpadding-right: 30px;\n\tjustify-content: flex-end;\n}\n\n.topbar .navbar .navbar-nav .nav-link {\n\tpadding-right: .8rem;\n\tpadding-left: .8rem;\n\tcolor: var(--color-text-dark);\n\tfont-size: 22px\n}\n\n.user-box {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 45px;\n    width: 55px;\n    border-left: 0px solid var(--color-border-light);\n    margin-left: 1rem;\n    margin-right: -1rem;\n    padding-left: 0;\n}\n\n.user-img {\n\twidth: 38px;\n    height: 38px;\n    border-radius: 50%;\n    border: 0 solid #e5e5e5;\n    padding: 0;\n    font-size: 32px;\n    color: var(--color-icon-muted);\n}\n\n.user-info .user-name {\n\tfont-size: 15px;\n\tfont-weight: 500;\n\tcolor: var(--color-white)\n}\n\n.user-info .designattion {\n\tfont-size: 13px;\n\tcolor: var(--color-white)\n}\n\n.user-box .dropdown-menu i {\n\tvertical-align: middle;\n\tmargin-right: 10px\n}\n\n.dropdown-menu {\n\t-webkit-box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15);\n\tbox-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15);\n\tborder: 0 solid var(--color-border-light);\n\tborder-radius: 10px;\n\tfont-size: 14px\n}\n\n.dropdown-toggle-nocaret:after {\n\tdisplay: none\n}\n\n.topbar .navbar .dropdown-large .dropdown-menu::after {\n\tcontent: '';\n\twidth: 13px;\n\theight: 13px;\n\tbackground: var(--color-white);\n\tposition: absolute;\n\ttop: -6px;\n\tright: 16px;\n\ttransform: rotate(45deg);\n\tborder-top: 1px solid #ddd;\n\tborder-left: 1px solid #ddd\n}\n\n.topbar .navbar .dropdown-menu::after {\n\tcontent: '';\n\twidth: 13px;\n\theight: 13px;\n\tbackground: var(--color-white);\n\tposition: absolute;\n\ttop: -6px;\n\tright: 16px;\n\ttransform: rotate(45deg);\n\tborder-top: 1px solid #ddd;\n\tborder-left: 1px solid #ddd\n}\n\n.topbar .navbar .dropdown-menu {\n\t-webkit-animation: .6s cubic-bezier(.25, .8, .25, 1) 0s normal forwards 1 animdropdown;\n\tanimation: .6s cubic-bezier(.25, .8, .25, 1) 0s normal forwards 1 animdropdown\n}\n.designation-icon {\n    color: var(--color-icon-muted);\n    font-size: 15px;\n    width: 20px;\n    flex-shrink: 0;\n    text-align: center;\n    margin-top: 2px;\n    margin-left: 15px;\n}\n\n.designation-text {\n    font-size: 14px;\n    color: var(--color-text-dark);\n    line-height: 1.4;\n}\n\n.company-select-box {\n    position: relative;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    min-height: 38px;\n    padding: 8px 14px;\n    background: var(--color-white);\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n}\n\n.company-selected-text {\n    color: var(--color-text-dark);\n    font-size: 14px;\n    flex: 1;\n    padding-left: 8px;\n    white-space: normal;\n    word-break: break-word;\n    line-height: 1.4;\n}\n\n.company-arrow {\n    margin-top: 2px;\n}\n\n/* .company-arrow {\n    color: #6c757d;\n    font-size: 9px;\n    margin-left: auto;\n} */\n\n.custom-company-dropdown {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    right: 0;\n    background: var(--color-bg-panel);\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    border-radius: 10px;\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);\n    list-style: none;\n    margin: 0;\n    padding: 6px 0;\n    z-index: 20;\n    max-height: 220px;\n    overflow-y: auto;\n}\n\n.custom-company-dropdown li {\n    padding: 10px 14px;\n    color: var(--color-text-dark);\n    font-size: 14px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n}\n\n.custom-company-dropdown li:hover {\n    background: rgba(0, 0, 0, 0.05);\n}\n\n.custom-company-dropdown li.active {\n    color: var(--color-primary-orange);\n    font-weight: 600;\n}\n.topbar .navbar .dropdown-menu {\n    background: var(--color-bg-panel);\n\tborder: 1px solid rgba(0, 0, 0, 0.08);\n    min-width: 260px;\n    border-radius: 14px;\n    overflow: visible;\n}\n\n.dropdown-user-img {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    background: var(--color-white);\n    color: var(--color-primary-green);\n    font-size: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n}\n\n.dropdown-user-info .user-name {\n    font-size: 15px;\n    /* font-weight: 600; */\n    color: var(--color-text-dark);\n}\n\n.dropdown-user-info .designattion {\n    font-size: 13px;\n    color: var(--color-text-dark);\n}\n.topbar .navbar .dropdown-menu::after {\n    border-radius: 2px;\n}\n.topbar .navbar .dropdown-menu .dropdown-item {\n    color: var(--color-text-dark) !important;\n    opacity: 1 !important;\n    background: transparent !important;\n\tpadding: 4px 14px !important;\n}\n\n.topbar .navbar .dropdown-menu .dropdown-item:hover {\n    background: transparent !important;\n    color: #7f8991 !important;\n}\n.company-select-box .company-select option {\n    background: var(--color-bg-panel);\n    color: var(--color-text-dark);\n    font-size: 14px;\n    font-family: inherit;\n    padding: 8px 12px;\n}\n\n.company-select-box .company-select option:checked,\n.company-select-box .company-select option:hover {\n    background: var(--color-primary-orange);\n    color: var(--color-white);\n}\n.topbar .navbar .dropdown-menu .dropdown-divider {\n    margin: 0 !important;\n}\n\n.mobile-portal-toggle {\n\tdisplay: none;\n}\n\n@media (max-width: 768px) {\n\t.topbar .navbar > div[style*=\"display: flex\"] > .portal-toggle-container,\n\t.topbar .navbar .portal-toggle-container {\n\t\tdisplay: none !important;\n\t}\n\n\t.ticketing-link {\n\t\tdisplay: none !important;\n\t}\n\n\t.mobile-portal-toggle {\n\t\tdisplay: flex !important;\n\t}\n    .user-info {\n\t\tpadding-right: 18px;\n\t}\n}\n@media (max-width: 768px) {\n  .ticketing-link {\n    display: none !important;\n  }\n}\n.mobile-quick-links {\n    display: none;\n}\n\n@media (max-width: 768px) {\n    .mobile-quick-links {\n        display: block;\n    }\n}\n\n.mobile-quick-link-item {\n    display: flex;\n    align-items: center;\n    padding: 8px 0;\n    color: var(--color-text-dark);\n    font-size: 14px;\n    cursor: pointer;\n    margin-left: 10px;\n}\n\n.mobile-quick-link-item:hover {\n    color:var(--color-primary-orange);\n}\n\n.mobile-quick-link-item i {\n    color:var(--color-primary-orange);\n    width: 20px;\n}\n@media (max-width: 768px) {\n    .topbar {\n    height: 45px;\n  }\n  .topbar .navbar {\n    height: 45px;\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\n  .toggle-menu {\n    height: 56px;\n    padding: 0 10px !important;\n    font-size: 20px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  \n  .company-logo {\n    width: 32px !important;\n    height: 45px !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    object-fit: contain;\n    display: block;\n  }\n  .user-info {\n    padding-left: 1px !important;\n    padding-right: 1px !important;\n    color: var(--color-primary-green) !important;\n    /* background-color: var(--color-primary-green) !important; */\n  }\n\n  .dropdown-user-img {\n    width: 28px !important;\n    height: 28px !important;\n    font-size: 18px !important;\n     margin-left: -10px;\n  }\n  \n}\n.dropdown-item-icon {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-left: 10px;\n}\n\n.dropdown-item-icon i {\n    width: 20px;\n    text-align: center;\n    color:var(--color-primary-green);\n    flex-shrink: 0;\n    \n}\n.dropdown-icon-self {\n    width: 10px;\n    text-align: center;\n    color: var(--color-primary-green);\n    flex-shrink: 0;\n    \n}\n.quick-apps-trigger {\n    height: 32px;\n    width: 32px;\n    border-radius: 8px;\n    background: rgba(255, 255, 255, 0.25);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: var(--color-white);\n    font-size: 15px;\n}\n\n.quick-apps-trigger:hover {\n    background: rgba(255, 255, 255, 0.4);\n}\n\n.quick-apps-panel {\n    position: absolute;\n    top: calc(100% + 10px);\n    right: 0;\n    background: var(--color-white);\n    border-radius: 14px;\n    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.15);\n    padding: 16px;\n    display: flex;\n    gap: 20px;\n    z-index: 200;\n}\n\n.quick-apps-panel::after {\n    content: '';\n    position: absolute;\n    top: -6px;\n    right: 16px;\n    width: 13px;\n    height: 13px;\n    background: var(--color-white);\n    transform: rotate(45deg);\n    box-shadow: -2px -2px 3px -1px rgba(0, 0, 0, 0.06);\n}\n\n.quick-app-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n    width: 70px;\n}\n\n.quick-app-item span {\n    font-size: 12px;\n    color: var(--color-text-dark);\n    text-align: center;\n    line-height: 1.3;\n}\n\n.quick-app-icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--color-white);\n    font-size: 20px;\n}\n\n.quick-app-icon-red { background: #e0435c; }\n.quick-app-icon-teal { background: #14a89d; }\n\n.quick-links-trigger {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: var(--color-primary-orange);\n    color: var(--color-white);\n    font-size: 0.8rem;\n    font-weight: 600;\n    padding: 6px 14px;\n    border-radius: 20px;\n    cursor: pointer;\n    border: 1px solid var(--color-primary-green);\n    transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.quick-links-trigger:hover {\n    background: var(--color-primary-green);\n    border-color: var(--color-primary-green);\n}\n\n.quick-links-trigger-active {\n    background: var(--color-primary-green) !important;\n    border-color: var(--color-primary-green) !important;\n}\n\n.quick-links-chevron {\n    font-size: 11px;\n    transition: transform 0.2s ease;\n}\n\n.quick-links-chevron-open {\n    transform: rotate(180deg);\n}\n\n.quick-links-panel {\n    position: absolute;\n    top: calc(100% + 10px);\n    right: 0;\n    background: var(--color-white);\n    border-radius: 14px;\n    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.15);\n    padding: 6px 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    z-index: 200;\n}\n\n.quick-link-card {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 14px 16px;\n    cursor: pointer;\n    border-bottom: 1px solid #eef0f2;\n    transition: background 0.2s ease;\n    white-space: nowrap;\n}\n\n.quick-link-card:last-child {\n    border-bottom: none;\n}\n\n.quick-link-card:hover {\n    background: var(--color-bg-hover);\n}\n\n.quick-link-card-icon {\n    font-size: 14px;\n    color: var(--color-primary-orange);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.quick-link-divider {\n    width: 1px;\n    height: 18px;\n    background: rgba(255, 255, 255, 0.3);\n}\n.portal-toggle-container-mobile {\n    display: inline-flex;\n    width: 100%;\n    background: var(--color-white);\n    border-radius: 20px;\n    padding: 4px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    border: 1px solid var(--color-border-light);\n}\n\n.portal-toggle-btn {\n    flex: 1;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 13px;\n    padding: 6px 16px;\n    border-radius: 16px;\n    border: none;\n    transition: all 0.3s ease;\n    white-space: nowrap;\n    background: transparent;\n    color: #666666;\n}\n\n.portal-toggle-btn-active {\n    background: var(--color-primary-green);\n    color: var(--color-white);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
